import React, { createContext, useContext } from 'react';
import { useWishlist } from '../hooks/useWishlist';

const WishlistContext = createContext();

export function WishlistProvider({ children }) {
  const wishlistState = useWishlist();
  return (
    <WishlistContext.Provider value={wishlistState}>
      {children}
    </WishlistContext.Provider>
  );
}

export function useWishlistContext() {
  const context = useContext(WishlistContext);
  if (!context) {
    throw new Error('useWishlistContext must be used within a WishlistProvider');
  }
  return context;
}